export const getFluidImage = (post, allGatsbyImageData) => {
  const thumb = post.thumbnail.split('/')[3]
  return allGatsbyImageData.filter(node => node.relativePath === thumb)[0]
    .childImageSharp.fluid
}
